import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { CashflowPrevisionnelRow, TopRetardRow } from '@/lib/database.types';

export function useCashflowPrevisionnel(entrepriseId: string | null, days = 90) {
  return useQuery({
    queryKey: ['cashflow', entrepriseId, days],
    enabled: !!entrepriseId,
    queryFn: async (): Promise<CashflowPrevisionnelRow[]> => {
      if (!entrepriseId) return [];
      const today = new Date();
      const end = new Date(today.getTime() + days * 86400000);
      const fmt = (d: Date) => d.toISOString().slice(0, 10);
      const { data, error } = await supabase
        .from('v_cashflow_previsionnel')
        .select('*')
        .eq('entreprise_id', entrepriseId)
        .gte('jour', fmt(today))
        .lte('jour', fmt(end))
        .order('jour', { ascending: true });
      if (error) throw error;
      return (data ?? []) as unknown as CashflowPrevisionnelRow[];
    },
  });
}

export function useTopRetards(entrepriseId: string | null) {
  return useQuery({
    queryKey: ['top_retards', entrepriseId],
    enabled: !!entrepriseId,
    queryFn: async (): Promise<TopRetardRow[]> => {
      if (!entrepriseId) return [];
      const { data, error } = await supabase
        .from('v_top_retards_tiers')
        .select('*')
        .eq('entreprise_id', entrepriseId)
        .order('total_du', { ascending: false })
        .limit(20);
      if (error) throw error;
      return (data ?? []) as unknown as TopRetardRow[];
    },
  });
}
